import React, { useState } from 'react';

export default function IconBoxVisionMission({ title, iconUrl, subTitle }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <style>
        {`
          @keyframes swivel {
            0% {
              transform: perspective(1000px) rotateY(0deg);
            }
            25% {
              transform: perspective(1000px) rotateY(5deg);
            }
            50% {
              transform: perspective(1000px) rotateY(0deg);
            }
            75% {
              transform: perspective(1000px) rotateY(-5deg);
            }
            100% {
              transform: perspective(1000px) rotateY(0deg);
            }
          }
          .vision-mission-card {
            animation: swivel 3s ease-in-out infinite;
            transition: all 0.3s ease;
          }
          .vision-mission-card:hover {
            animation-play-state: paused;
            transform: perspective(1000px) rotateY(10deg) scale(1.05);
          }
        `}
      </style>
      <div 
        className="vision-mission-card"
        style={{ 
          height: '100%',
          minHeight: '320px',
          backgroundColor: '#e6f2ff',
          borderRadius: '20px',
          padding: '40px 30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          boxShadow: '0 8px 25px rgba(101, 80, 201, 0.15)',
          border: '2px solid rgba(204, 229, 255, 0.8)',
          position: 'relative',
          overflow: 'hidden'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Decorative background element */}
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '150px',
          height: '150px',
          backgroundColor: 'rgba(204, 229, 255, 0.3)',
          borderRadius: '50%',
          zIndex: 0
        }} />
        <div style={{
          position: 'absolute',
          bottom: '-30px',
          left: '-30px',
          width: '100px',
          height: '100px',
          backgroundColor: 'rgba(204, 229, 255, 0.2)',
          borderRadius: '50%',
          zIndex: 0
        }} />
        
        <div style={{ position: 'relative', zIndex: 1, width: '100%' }}>
          <div style={{
            width: '80px',
            height: '80px',
            backgroundColor: '#6550C9',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 25px',
            boxShadow: '0 4px 15px rgba(101, 80, 201, 0.3)'
          }}>
            <img 
              src={iconUrl} 
              alt="Icon" 
              style={{ 
                width: '45px', 
                height: '45px',
                filter: 'brightness(0) invert(1)'
              }} 
            />
          </div>
          
          <h2 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#6550C9',
            margin: '0 0 20px 0',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            {title}
          </h2>
          
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#555',
            margin: 0,
            maxWidth: '100%'
          }}>
            {subTitle}
          </p>
        </div>
      </div>
    </>
  );
}

